export default {
  name: 'Adrawer',
  props: {
    visible: { type: Boolean, default: () => false },
  },
  render() {
    const { size = '20%', ...attrs } = this.$attrs;
    return (
      <el-drawer size={size} visible={this.visible} {...{ attrs }}>
        <div class="a-drawer-container">{this.slots.default}</div>
      </el-drawer >
    );
  }
}